var menu = document.getElementById('menu'),
	menuButton = document.getElementById('menu-button'),
	menuContainer = document.getElementById('menu-container');

body.addEventListener('click', function(e) {
	checkAndCloseMenu(e.target);
});

document.addEventListener('keydown', function(e) {
	if(e.key == 'Escape')
		checkAndCloseMenu(menu);
});

// Shadows
window.addEventListener("scroll", (event) => {
	let scroll = window.scrollY;
	if (scroll > 10) {
	  document.getElementById('header').classList.add("shadow");
	} else {
	  document.getElementById('header').classList.remove("shadow");
	}
});

function checkAndCloseMenu(e) {
	var open = openMenu(e);

	if(open) {
		closeMenu(open);
		toggleMenuBodyClass(false);
	}
}

[].slice.call(navwrap.querySelectorAll('button:not([type="submit"]):not(.lang-button)')).forEach(function(navLink) {
	navLink.addEventListener('click', toggleMenu);
});

function toggleMenu() {
	closeMenu(openMenu(this));

	var parent = this.parentNode.parentNode,
		openSibling = parent.querySelector('.open');

	if(parent.classList.contains('submenu') && openSibling && openSibling != this)
		closeMenu(openSibling);

	var isOpen = this.classList.contains('open'),
		animation = menu.contains(this) ? (isOpen ? 'slideUp' : 'slideDown') : (isOpen ? 'fadeOut' : 'fadeIn')
		display = isOpen ? 'none' : 'block';

	Velocity(this.nextElementSibling, animation, {duration: 300, display: display});

	this.classList.toggle('open');

	this.setAttribute('aria-expanded', (this.getAttribute('aria-expanded') == 'true' ? 'false' : 'true'));

	toggleMenuBodyClass(navwrap.querySelector('.open'));
}

function closeMenu(el) {
	if(el) {
		var submenu = el.nextElementSibling;

		if(submenu)
			Velocity(submenu, menu.contains(el) ? 'slideUp' : 'fadeOut', {duration: 300});

		el.classList.remove('open');

		if(submenu)
			closeMenu(submenu.querySelector('.open'));
	}
}

function openMenu(el) {
	if(menuButton && menuButton.classList.contains('open') && menuButton != el && !menuButton.contains(el) && !document.getElementById('menu-container').contains(el))
		return menuButton;

	var openButton = navwrap.querySelector('button:not(#menu-button).open');

	return openButton && !openButton.parentNode.contains(el) ? openButton : false;
}

function toggleMenuBodyClass(open) {
	if(open)
		body.classList.add('menu-open');
	else
		body.classList.remove('menu-open');

	setFocus((open ? true : false), header);
}